export function needToNormalize(url: string): boolean {
  if (url === "/") {
    return false;
  }
  const validUrlRegex =
    /^(?!.*(?<!https?:)\/{2,})(?:https?:\/\/)?[^?#]*\/(?:\?[^#]*)?(?:#.*)?$/;
  return !validUrlRegex.test(url);
}

export function normalizeUrl(url: string): string {
  // Извлекаем протокол, если он присутствует (абсолютные URL)
  // для того, чтобы не затронуть "://" в начале.
  let protocol = "";
  let rest = url;
  const protocolMatch = url.match(/^(https?:\/\/)/);
  if (protocolMatch) {
    protocol = protocolMatch[1];
    rest = url.slice(protocol.length);
  }

  // Заменяем все последовательности из 2-х и более слешей на один.
  // Это применимо как для абсолютных, так и для относительных путей.
  rest = rest.replace(/\/{2,}/g, "/");

  // Разбиваем оставшуюся часть URL на путь, строку запроса и якорь.
  let path = rest;
  let query = "";
  let hash = "";
  const queryIndex = rest.indexOf("?");
  const hashIndex = rest.indexOf("#");

  if (queryIndex !== -1 && (hashIndex === -1 || queryIndex < hashIndex)) {
    path = rest.substring(0, queryIndex);
    query = rest.substring(
      queryIndex,
      hashIndex !== -1 ? hashIndex : undefined,
    );
    if (hashIndex !== -1) {
      hash = rest.substring(hashIndex);
    }
  } else if (hashIndex !== -1) {
    path = rest.substring(0, hashIndex);
    hash = rest.substring(hashIndex);
  }

  // Если путь не заканчивается на '/', добавляем его.
  if (!path.endsWith("/")) {
    path += "/";
  }

  // Собираем нормализованный URL обратно: протокол (если был) + путь + запрос + якорь.
  return path + query + hash;
}
